import { useMainContext } from './useMainContext';

export { useMainContext };
